import { Track } from '@volvo-cars/tracking';
import { Spacer } from 'vcc-ui';

import { ContentWrapper, H2, H3, Image, Link, Paragraph } from '@collab/atoms';
import {
  Callout,
  HeroImage,
  PageTitle,
  TextStatement,
} from '@collab/molecules';

import RestrictedVolvoUserContent from 'atoms/RestrictedVolvoUserContent';
import GitHubSmallIcon from 'icons/GitHubSmall';
import PageSeo from 'libs/seo/PageSeo';
import LoginStatusCallout from 'molecules/LoginStatusCallout';
import Markdown from 'molecules/Markdown';
import StepList from 'molecules/StepList';
import CardGrid from 'organisms/CardGrid';
import Faq from 'organisms/Faq';
import { PageProps } from 'types/pages';

const InCarApps: React.FC<PageProps> = ({ content, pageMeta }) => (
  <>
    <PageSeo
      title={pageMeta.title}
      category={pageMeta.category}
      {...pageMeta.seo}
    />
    <ContentWrapper>
      <PageTitle title={pageMeta.title} category={pageMeta.category} />
    </ContentWrapper>
    <HeroImage {...content.heroImage} />
    <ContentWrapper>
      <TextStatement {...content.textStatement} />
      <H2>{content.poweredByAndroid.heading}</H2>
      <Markdown>{content.poweredByAndroid.body}</Markdown>
      <Image
        {...content.poweredByAndroid.image}
        aspectRatio={{ default: [21, 9], mobile: [1, 1] }}
      />
      <Track
        eventAction="link|click"
        eventLabel={content.poweredByAndroid.link.href}
      >
        <Link
          className="button-text self-start text-accent-blue"
          href={content.poweredByAndroid.link.href}
        >
          {content.poweredByAndroid.link.text}
        </Link>
      </Track>
      <H2>{content.buildTestRelease.heading}</H2>
      <Markdown>{content.buildTestRelease.body}</Markdown>
      <Spacer size={[4, 5]} />
      <StepList items={content.buildTestRelease.list} />
      <LoginStatusCallout
        statusTexts={content.buildTestRelease.loginStatusCallout}
      />
      <RestrictedVolvoUserContent>
        <H3>{content.buildTestRelease.restricted.title}</H3>
        <Markdown>{content.buildTestRelease.restricted.text}</Markdown>
        <Spacer size={[4, 5]} />
        <CardGrid cards={content.buildTestRelease.restricted.cards} />
      </RestrictedVolvoUserContent>
      <div className="mt-48 md:mt-64">
        <Callout
          title={content.buildTestRelease.gitHubCallout.title}
          content={
            <Paragraph>
              {content.buildTestRelease.gitHubCallout.content}
            </Paragraph>
          }
          icon={<GitHubSmallIcon />}
          button={
            <Track
              eventAction="link|click"
              eventLabel={
                content.buildTestRelease.gitHubCallout.button.buttonText
              }
            >
              <Link
                href={content.buildTestRelease.gitHubCallout.button.href}
                className="button-outlined"
                aria-label="Explore Android Automotive code samples"
              >
                {content.buildTestRelease.gitHubCallout.button.buttonText}
              </Link>
            </Track>
          }
        />
      </div>
      <H2>{content.faq.heading}</H2>
      <Faq
        items={content.faq.items}
        structuredData={content.faq.structuredData}
      />
    </ContentWrapper>
  </>
);

export default InCarApps;
